<template>
<div>
  <van-row type="flex" justify="end" style="margin: 2rem 1rem;">
    <van-col span="18">
      <div style="margin: 15px 5px; font-size: 24px;color: #102233;">{{ displayname }},欢迎您！</div>
    </van-col>
    <van-col span="6" style="text-align: right;">
      <van-image
        width="4rem"
        height="4rem"
        fit="cover"
        error-icon="//static.passport.yqda.net/avatar/5/15/d5f39c259078fa9fcbded802f3b368.png"
        round
        :src="userinfo.avatar"
      />
    </van-col>
  </van-row>
  <van-cell title="浏览记录" value="去查看" size="large" is-link to="History" />
  <!--van-cell title="我的收藏" :value="去查看" size="large" is-link to="Favlist" /-->
  <van-cell title="我的会员" value="会员卡列表" size="large" is-link to="Cards" />
  <van-cell title="我的订单" value="查看订单" size="large" is-link to="Orders" />
  <van-cell title="绑定手机" :value="userinfo.mobile" size="large" is-link to="BindMobile" />
  <van-cell title="身份认证" :value="verifyText" size="large" is-link to="Verify" />
  <van-cell title="登录密码" value="修改密码" size="large" is-link to="SetPassword" />
  <van-cell title="绑定邮箱" :value="bindemailText" size="large" is-link to="BindMail" />
  <van-cell title="登录记录" value="去查看" size="large" is-link to="LoginRecord" />
</div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import Vue from 'vue';
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
export default {
  computed: {
    ...mapGetters({
      userinfo: 'user/userinfo'
    }),
    displayname () {
      return this.userinfo.realname !== null ? this.userinfo.realname : this.userinfo.username
    },
    verifyText: function () {
      return this.userinfo.idcardnumber !== null ? '已实名' : '去实名'
    },
    bindemailText: function () {
      return (this.userinfo.email !== ''&&this.userinfo.email !== null) ? '已绑定' : '去绑定'
    }
  }
}
</script>
